import React, { useEffect } from 'react';
import { IoMdCloseCircleOutline } from "react-icons/io";
import './ModalV3.scss';

const ModalV3 = ({
    isOpen,
    onClose,
    width = '500px',
    height = 'auto',
    children,
    closeOnBackdrop = true,
    closeOnEsc = true,
    disableManualClose = false,
}) => {

    useEffect(() => {
        if (closeOnEsc && !disableManualClose && isOpen) {
            const handleEsc = (event) => {
                if (event.key === 'Escape') handleClose();
            };
            window.addEventListener('keydown', handleEsc);
            return () => window.removeEventListener('keydown', handleEsc);
        }
    }, [closeOnEsc, disableManualClose, isOpen]);

    const handleClose = () => {
        onClose?.();
    };

    if (!isOpen) return null;

    return (
        <div
            className="modalv3-overlay"
            onClick={!disableManualClose && closeOnBackdrop ? handleClose : undefined}
        >
            <div
                className={`modalv3-content ${isOpen && 'enter'}`}
                style={{ width, height }}
                onClick={(e) => e.stopPropagation()}
            >
                {!disableManualClose && (
                    <button className="modalv3-close-btn" onClick={handleClose}>
                        <IoMdCloseCircleOutline size={28} />
                    </button>
                )}
                {children}
            </div>
        </div>
    );
};

export default ModalV3;